import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { callStartGateway } from './call-start-gateway'
import { CampaignCode } from '../models/CampaignCode'
import { CallLogLookUp } from '../models/call-log-lookup'
import { DispositionLookUP } from '../models/disposition-lookup'
import { Emailorder } from '../models/EmailOrder'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'

import { ActivatedRoute, Router, RoutesRecognized, NavigationStart, NavigationEnd } from '@angular/router'
import { filter, pairwise } from 'rxjs/operators'

@Injectable()
export class NetworkCallStartGateway extends callStartGateway {
    timerMs: number = 0
    callLogLookUp: CallLogLookUp = {} as CallLogLookUp
    emailConfirm: string
    emailOrder: Emailorder = {} as Emailorder
    private history: string[] = []

    constructor(private http: HttpClient, private routers: Router) {
        super()
        this.loadRouting()
    }

    public loadRouting(): void {
        this.routers.events
            .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
                this.history = [...this.history, urlAfterRedirects]
            })
    }
    public getPreviousUrl(): string {
        return this.history[this.history.length - 2] || '/index'
    }

    verifyVdn(vdn: number): Observable<CampaignCode> {
        return this.http.get<CampaignCode>('../api/callstart/GetCampaignData/' + vdn)
    }

    setCallLogLookUpModel(value: CallLogLookUp) {
        this.callLogLookUp = value
    }
    getCallLogLookUpModel(): CallLogLookUp {
        return this.callLogLookUp
    }

    getStateAbbrByZipCode(zipcode: string): Observable<ValidatedSelectOptionModel[]> {
        return this.http.get<ValidatedSelectOptionModel[]>('../api/callstart/getStateAbbrByZipCode/' + zipcode)
    }

    getStateByZipCode(zipcode: string): Observable<string> {
        return this.http.get<string>('../api/callstart/getStateByZipCode/' + zipcode)
    }

    getDispositionByPlanYear(planYear: string): Observable<DispositionLookUP[]> {
        return this.http.get<DispositionLookUP[]>('../api/callstart/getdispositionbyplanyear/' + planYear)
    }

    saveCallLogLookUp(model: CallLogLookUp): Observable<number> {
        let body = JSON.stringify(model)
        return this.http.post<number>('../api/callstart/saveCallLogLookUP', body)
    }
    updatedispositionId(dispositionId: number, calllogId: number): Observable<number> {
        return this.http.get<number>('../api/callstart/updatedispositionid/' + dispositionId + '/' + calllogId)
    }
    getTimer() {
        return this.timerMs
    }
    setTimer(value: number) {
        this.timerMs = value
    }
    getEmailConfirm() {
        return this.emailConfirm
    }
    setEmailConfirm(value: string) {
        this.emailConfirm = value
    }
    setEmailOrder(value: Emailorder) {
        this.emailOrder = value
    }
    getEmailOrder() {
        return this.emailOrder
    }
    saveEmailOrder(model: Emailorder): Observable<number> {
        let body = JSON.stringify(model)
        return this.http.post<any>('../api/callstart/insertEmailOrder', body)
    }

    downloadPDF(campaignCode: CampaignCode): Observable<any> {
        var downloadData = this.http.post<any>('../api/downloadPdfLink', JSON.stringify(campaignCode))
        return downloadData
    }

    getRegionIDbyZipCode(value: string): Observable<number> {
        return this.http.get<number>('../api/callstart/getRegionIDbyZipCode/' + value)
    }
    getCallStartTime(): Observable<string> {
        let getUrl = '../api/callstart/getCallStartTime'
        return this.http.get<string>(getUrl)
    }
}
